import React, { useState, useEffect } from 'react';
import axios from '../../common/axios';
import { Alert } from 'antd';
import CircularLoader from '../../common/CircularLoader';

const CustomActivity = ({ step, stepActivity }) => {
    const [isLoading, setLoading] = useState(true);
    const [customActivity, setCustomActivity] = useState();
    const [error, setError] = useState();

    useEffect(() => {
        // Flag to track if this specific effect execution is still active
        let isActive = true;

        if (!step || !stepActivity?.customActivityId) {
            setCustomActivity(undefined);
            setError(undefined);
            setLoading(false);
            return;
        }

        const loadCustomActivity = async (customActivityId) => {
            setLoading(true);
            setError(undefined);
            try {
                const response = await axios.get('/web/ui/trail/customActivity', {
                    params: { customActivityId },
                });

                if (isActive) {
                    setCustomActivity(response.data);
                }
            } catch (err) {
                if (isActive) {
                    console.error('Error loading custom activity:', err);
                    setError('Failed to load activity. Please try again.');
                }
            } finally {
                if (isActive) {
                    setLoading(false);
                }
            }
        };

        loadCustomActivity(stepActivity.customActivityId);

        // Cleanup function: marks this effect as inactive when the component unmounts
        // or when step/stepActivity changes
        return () => {
            isActive = false;
        };
    }, [step, stepActivity]);

    if (isLoading) {
        return (
            <div role="status" aria-busy="true" aria-live="polite">
                <CircularLoader />
            </div>
        );
    }

    if (error) {
        return <Alert showIcon={true} message={error} type="error" role="alert" />;
    }

    if (!customActivity) {
        return <Alert showIcon={true} message="Activity not found" type="error" role="alert" />;
    }

    const hasMultipleLinks = Array.isArray(customActivity.links) && customActivity.links.length > 1;
    const hasSingleLink = Array.isArray(customActivity.links) && customActivity.links.length === 1;

    return (
        <section className="ch-trail-custom-activity" aria-labelledby="custom-activity-title">
            <h3 id="custom-activity-title">{customActivity.title}</h3>

            {customActivity.message && <p>{customActivity.message}</p>}

            {hasSingleLink && (
                <div>
                    <h3>Quick Link</h3>
                    <p>
                        <a
                            className="ch-link"
                            href={customActivity.links[0].linkUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`Quick link to ${customActivity.links[0].linkUrl}`}
                        >
                            {customActivity.links[0].linkUrl}
                        </a>
                    </p>
                </div>
            )}

            {hasMultipleLinks && (
                <div>
                    <h3>Quick Links</h3>
                    <ul>
                        {customActivity.links.map((link, index) => (
                            <li key={index}>
                                <a
                                    className="ch-link"
                                    href={link.linkUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={`Quick link ${index + 1} to ${link.linkUrl}`}
                                >
                                    {link.linkUrl}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </section>
    );
};

export default CustomActivity;